import { StringMap } from '@angular/compiler/src/compiler_facade_interface';
import { Injectable } from '@angular/core';
import { AutoExecutor } from 'src/app/_models/auto-executor';

@Injectable({
  providedIn: 'root'
})
export class InitialNotificationsService {

  private initialNotificationTitle: string;
  private autoExecutorInfo: AutoExecutor;
  private notificationId: number;
  constructor() { }

  public setInitialNotifiactionTitle(notificationTitle: string){
    this.initialNotificationTitle = notificationTitle;
  }

  public getInitialNotificationTitle(): string{
    return this.initialNotificationTitle;
  }

  public setAutoExecutorMessage(autoExecutorInfo: AutoExecutor){
    this.autoExecutorInfo = autoExecutorInfo;
  }

  public getAutoExecutorMessage(): AutoExecutor{
    return this.autoExecutorInfo;
  }

  public setNotificationId(notificationId: number){
    this.notificationId = notificationId;
  }

  public getNotificationId(){
    return this.notificationId
  }
}
